import * as yup from "yup";

import {
  PhoneType,
  ConnectionMode,
  ExtensionType,
  OutboundPhoneMode,
  RecordingControls,
} from "../../types";

const PHONE_TYPES = Object.values(PhoneType);
const CONNECTION_MODES = Object.values(ConnectionMode);
const EXTENSION_TYPES = Object.values(ExtensionType);
const OUTBOUND_PHONE_MODES = Object.values(OutboundPhoneMode);
const RECORDING_CONTROL_MODES = Object.values(RecordingControls);

const phoneSchema = yup.object({
  phone_type: yup.string().oneOf(PHONE_TYPES),
  pstn_number: yup.string(),
  pstn_number_change_enabled: yup.boolean(),
  ip_uri: yup
    .string()
    .max(250)
    .matches(/([^@].+)@(.+)/, "${label} should be valid IP URI"),
  ip_uri_change_enabled: yup.boolean(),
  phone_settings_validated: yup.boolean(),
  auto_answer_enabled: yup.boolean(),
  pbx_number: yup.number(),
  connection_mode: yup.string().oneOf(CONNECTION_MODES),
  connection_mode_change_enabled: yup.boolean(),
  extension_number: yup.number(),
  extension_type: yup.string().oneOf(EXTENSION_TYPES),
  dar_enabled: yup.boolean(),
  dar_voicemail_enabled: yup.boolean(),
  calling_line_id: yup.string(),
  outbound_phone_mode: yup.string().oneOf(OUTBOUND_PHONE_MODES),
  recording_percentage_queued_inbound_calls: yup.number().min(0).max(100),
  recording_percentage_direct_inbound_calls: yup.number().min(0).max(100),
  recording_percentage_outbound_calls: yup.number().min(0).max(100),
  recording_controls: yup.string().oneOf(RECORDING_CONTROL_MODES),
});

export default phoneSchema;
